/**
 * Nginx Configuration State Store
 * Tracks pending SSL configuration changes
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface NginxConfigState {
    hasPendingChanges: boolean;
    lastChangeTimestamp: number | null;
    lastAppliedTimestamp: number | null;

    // Actions
    markPendingChanges: () => void;
    clearPendingChanges: () => void;
}

export const useNginxConfigStore = create<NginxConfigState>()(
    persist(
        (set) => ({
            hasPendingChanges: false,
            lastChangeTimestamp: null,
            lastAppliedTimestamp: null,

            markPendingChanges: () => set({
                hasPendingChanges: true,
                lastChangeTimestamp: Date.now()
            }),

            clearPendingChanges: () => set({
                hasPendingChanges: false,
                lastAppliedTimestamp: Date.now()
            })
        }),
        {
            name: 'nginx-config-state'
        }
    )
);
